module.exports = __webpack_public_path__ + "static/media/Exeggutor_gaussian2.f7315a1b.png";